import { MutableRefObject } from 'react';
import { fabric } from '../../../../vendor/fabric';

export const handleArrow = ({
  canvasRef,
  color,
  callback
}: {
  canvasRef: MutableRefObject<fabric.Canvas | null>;
  color: string;
  callback: () => void;
}) => {
  canvasRef.current.isDrawingMode = false;

  let arrow: any = null;
  let startX = 0;
  let startY = 0;

  // Remove any previous listeners to avoid stacking
  canvasRef.current.off('mouse:down');
  canvasRef.current.off('mouse:move');
  canvasRef.current.off('mouse:up');

  // Helper to create an arrow as a Fabric.Group (line + triangle head)
  const createArrow = (x1, y1, x2, y2, color) => {
    const angle = Math.atan2(y2 - y1, x2 - x1);
    const headlen = 18; // triangle width
    const headheight = 24; // triangle height

    // Line
    const line = new fabric.Line([x1 - 2, y1 - 2, x2 - 2, y2 - 2], {
      stroke: color,
      strokeWidth: 4,
      selectable: false,
      evented: false
    });

    // Arrowhead (triangle)
    const arrowHead = new fabric.Triangle({
      left: x2,
      top: y2,
      originX: 'center',
      originY: 'bottom',
      angle: (angle * 180) / Math.PI + 90,
      width: headlen,
      height: headheight,
      fill: color,
      selectable: false,
      evented: false
    });

    return new fabric.Group([line, arrowHead], {
      selectable: false,
      evented: false
    });
  };

  // Mouse down: start arrow
  canvasRef.current.on('mouse:down', opt => {
    const pointer = canvasRef.current.getPointer(opt.e);
    startX = pointer.x;
    startY = pointer.y;

    arrow = createArrow(startX, startY, startX, startY, color);
    canvasRef.current.add(arrow);
  });

  // Mouse move: update arrow end point
  canvasRef.current.on('mouse:move', opt => {
    if (!arrow) return;
    const pointer = canvasRef.current.getPointer(opt.e);

    // Remove old arrow and add new one
    canvasRef.current.remove(arrow);
    arrow = createArrow(startX, startY, pointer.x, pointer.y, color);
    canvasRef.current.add(arrow);
    canvasRef.current.renderAll();
  });

  // Mouse up: finalize arrow
  canvasRef.current.on('mouse:up', () => {
    if (arrow) {
      arrow.set({
        selectable: true,
        evented: true
      });
      canvasRef.current.setActiveObject(arrow);
      canvasRef.current.renderAll();
      arrow = null;
    }
    // Remove listeners after drawing
    canvasRef.current.off('mouse:down');
    canvasRef.current.off('mouse:move');
    canvasRef.current.off('mouse:up');
    callback();
  });
};
